import type { CustomValues } from '@atlassian/browser-metrics/types';

import { fg } from '@confluence/feature-gating';
import { networkTracker } from '@confluence/network';

import { browserMetricsState } from '../utils/browserMetricsState.ts';
import { transformObjectToFlattenCustomValuesType } from '../utils/transformObjectToFlattenCustomValuesType.ts';

export const frontendNetworkPlugin = ({}: {}): CustomValues => {
	// Only track frontend calls, skip during SSR
	// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
	if (process.env.REACT_SSR || typeof window === 'undefined') {
		if (fg('confluence_ufo_api_attribution_metrics')) {
			return {
				frontendTotalOperations: 0,
				apiCsrCount: 0,
			};
		}

		return {
			frontendTotalOperations: 0,
		};
	}

	const stats = networkTracker.getStats();

	if (!fg('confluence_ufo_api_attribution_metrics')) {
		return {
			frontendTotalOperations: stats.totalOperations,
		};
	}

	const pageLoadStats = networkTracker.getStatsSincePageLoadStart();
	const navigationType = browserMetricsState.transitionId === 0 ? 'initial' : 'transition';
	const boundaryNames = Object.keys(pageLoadStats.byBoundary ?? {}).sort();
	const boundaryFirstApiMetrics = transformObjectToFlattenCustomValuesType({
		apiByStreamingBoundary: Object.fromEntries(
			boundaryNames.map((boundaryName) => [
				boundaryName,
				{
					csr: {
						[navigationType]: {
							count: pageLoadStats.byBoundary[boundaryName],
						},
					},
				},
			]),
		),
	});

	return {
		frontendTotalOperations: stats.totalOperations,
		apiCsrCount: pageLoadStats.totalOperations,
		...boundaryFirstApiMetrics,
	};
};
